import { MenuDivider as ChakraMenuDivider } from "@chakra-ui/react";

const MenuDivider = () => <ChakraMenuDivider />;

export { MenuDivider };
